import { Loader } from '@sgme/ui';
import { SpTooltip } from 'components/shared/Tooltip/Tooltip';
import { IntlKey } from 'locales';
import { DropdownItem } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useAdvancedDropdownItem } from 'routes/essential-workspace/components/header/more-actions/advanced-item/use-advanced-item';

export function AdvancedDropdownItem() {
  const { disabledReasonTranslateKey, isDisabled, isLoading, openInAdvancedWorkspace } = useAdvancedDropdownItem();

  return (
    <SpTooltip
      disabled={!disabledReasonTranslateKey}
      contents={<FormattedMessage id={disabledReasonTranslateKey as IntlKey} />}
    >
      <div>
        <DropdownItem
          role="menuitem"
          onClick={openInAdvancedWorkspace}
          disabled={isDisabled}
          tabIndex={isDisabled ? -1 : undefined}
          as="button"
          className="flex-x gap-2"
        >
          <FormattedMessage id="essential.workspace.open.advanced.workspace.btn" />
          {isLoading ? (
            <Loader size="sm" purpose="spinner" aria-hidden="true" />
          ) : (
            <i className="icon icon-sm" aria-hidden="true">
              open_in_new
            </i>
          )}
        </DropdownItem>
      </div>
    </SpTooltip>
  );
}
